import { OrderActionsType,
	SET_SHIPPING_ADDRESS,
	SET_ORDER_ITEMS,
	SET_PAYMENT_METHOD
} from "../types/actions/Order.actions";

export type InitialState = {
	shippingAddress: any,
	orderItems: any;
	paymentMethod: string;
	paymentResult: any;
}

const initialState: InitialState = {
	shippingAddress: null,
	orderItems: [],
	paymentMethod: '',
	paymentResult: null
}

const orderReducer = (state = initialState, action: OrderActionsType) => {
	switch (action.type) {
		case SET_SHIPPING_ADDRESS:
			return {
				...state,
				shippingAddress: action.payload
			}
		case SET_ORDER_ITEMS:
			return {
				...state,
				orderItems: action.payload
			}
		case SET_PAYMENT_METHOD:
			return {
				...state,
				paymentMethod: action.payload.paymentMode,
				paymentResult: action.payload.paymentResult
			}
		default:
			return state;
  	}
};

export default orderReducer;
